module.exports = __webpack_public_path__ + "static/img_4981-cbff0a0b5f70259db6679f02f76cfceb.webp";